import { connect } from 'react-redux'
import { compose, withHandlers } from 'recompose'
import withType from 'components/common/hoc/withType'
import { QUOTE_SUMMARY_PAGE } from 'constant'
import { continueShopping, navigateToQuote } from './actions'
import ActionLinks from './ActionLinks'

const withNavigation = withHandlers({
  navigateToQuoteHandler: ({ navigateToQuote }) => () =>
    navigateToQuote(QUOTE_SUMMARY_PAGE)
})

export default compose(
  withType({ type: 'ActionLinks' }),
  connect(null, { continueShopping, navigateToQuote }),
  withNavigation
)(ActionLinks)
